import axiosInstance from "./AxiosInstance";

const getUserCart = async () => {
  try {
    const res = await axiosInstance.get("/api/cart/");
    return res.data;
  } catch (err: any) {
    if (err.response?.status === 401) {
      return { unauthorized: true };
    }
    console.error("Error fetching wishlist:", err);
    throw err;
  }
};

export default getUserCart;
